






































































































import 'vue2-timepicker/dist/VueTimepicker.css'
import {
  computed,
  defineComponent,
  reactive,
  SetupContext,
  Ref,
} from '@vue/composition-api'
import VueTimepicker from 'vue2-timepicker'

import { IReceipt, ReceiptType } from '@/types/receipt'
import { ReceiptValidation } from '@/types/ocr'
import { ChainStoreState, UserState } from '@/types/store'
import { IUser, UserRole } from '@/types/user'

import useVuex from '@/utils/useVuex'
import { dateToDisplay } from '@/utils/dateFormatter'
import { getShops } from '@/api/shops'

import { AppInput, AppAutocomplete } from '@/components/atoms'
import { DatePicker, TimePicker } from '@/components/molecules'
import SearchFromPhoneModal from '@/components/organisms/ocr/SearchFromPhoneModal.vue'
import { ChainStoreEntity } from '../../../../api/@types'

type Props = {
  receipt: IReceipt
  receiptType: ReceiptType
  validation: ReceiptValidation
  originalPhone: string | null
  isShopModified: boolean
  ngText: string
}

export default defineComponent({
  name: 'AbstractTable',
  components: {
    VueTimepicker,
    AppInput,
    AppAutocomplete,
    DatePicker,
    TimePicker,
    SearchFromPhoneModal,
  },
  props: {
    receipt: {
      type: Object,
      default: () => ({}),
    },
    receiptType: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
    originalPhone: {
      type: String,
      dafault: null,
    },
    isShopModified: {
      type: Boolean,
      default: false,
    },
    ngText: {
      type: String,
      default: '',
    },
  },
  setup(props: Props, context: SetupContext) {
    const store = context.root.$store

    const state = reactive<{
      chainStores: Ref<ChainStoreEntity[]>
      user: Ref<IUser | null>
      showDetail: boolean
      showContributor: boolean
    }>({
      chainStores: useVuex<ChainStoreState['chainStores']>(context, () =>
        props.receiptType !== 'shopUnchecked'
          ? store.getters['chainStore/allChainStores']
          : store.getters['chainStore/chainStores'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      showDetail: false,
      showContributor: false,
    })

    const isOcrPage = context.root.$router.currentRoute.path === '/ocr'

    const onClickReflectResult = (receipt: IReceipt) => {
      context.emit('update:receipt', receipt)
    }

    const onSelectDateTime = (dateTime: Date) => {
      const newReceipt: IReceipt = {
        ...props.receipt,
        dateTime,
        needReProcess: true,
      }
      context.emit('update:receipt', newReceipt)
    }

    const onChangePhone = (phone: string) => {
      const newReceipt = {
        ...props.receipt,
        phone,
      }
      context.emit('update:receipt', newReceipt)
    }

    const onChangeIsShopModified = (i: boolean) => {
      context.emit('update:isShopModified', i)
    }

    const onKeyupPhone = async (e: any) => {
      if (e.isComposing) {
        return
      }
      e.target.value = e.target.value
        .replace(/[ー－]/g, '-')
        .replace(/[０-９]/g, (s: string) => {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
        })
        .replace(/[^-\d]/g, '')

      const phone: string = e.target.value
      onChangePhone(phone)

      if (e.key !== 'Enter') {
        return
      }
      if (phone.length === 0) {
        return
      }
      const shops = await getShops(phone)
      if (shops.length === 0) {
        const newReceipt: IReceipt = {
          ...props.receipt,
          shop: null,
          shopId: null,
          chainStore: null,
          chainStoreId: null,
          channel: null,
          channelId: null,
          needReProcess: false,
        }
        context.emit('update:receipt', newReceipt)
        return
      }
      const newReceipt: IReceipt = {
        ...props.receipt,
        shop: shops[0],
        shopId: shops[0].id,
        chainStore: shops[0].chainStore,
        chainStoreId: shops[0].chain_store_id,
        channel: shops[0].chainStore.channel,
        channelId: shops[0].chainStore.channel_id,
        needReProcess: false,
      }
      if (props.receipt.chainStore === null) {
        // 新しくchainStore登録
        newReceipt.needReProcess = true
      } else {
        if (props.receipt.chainStoreId !== newReceipt.chainStoreId) {
          // chainStore変更
          newReceipt.needReProcess = true
        }
      }
      context.emit('update:receipt', newReceipt)
      context.emit('update:isShopModified', true)
    }

    const isNgChainStore = computed<boolean>(() => {
      if (props.receipt.chainStore === null) {
        return false
      }
      return props.receipt.chainStore.ng_flag === true
    })

    const importedToDisplay = computed(() => {
      return dateToDisplay(props.receipt.importedAt)
    })

    return {
      ...state,
      isOcrPage,
      onClickReflectResult,
      onSelectDateTime,
      onChangePhone,
      onChangeIsShopModified,
      onKeyupPhone,
      isNgChainStore,
      importedToDisplay,
      UserRole,
    }
  },
})
